/* Tidal Tank - Baseball Bundle add-on courses.
   Loaded globally (assets_theme.liquid). Handles:
   - the landing-page Custom Complete Product block (server-rendered add-on -> relocate above ATC)
   - the collection "Choose options" quick-add modal for the Baseball Bundle (inject add-on)
   - adding the ticked courses to the cart on Add to Cart, then registering them with the
     Fast Bundle add-on offer so Fast Bundle's own discount makes them free
   Survives section/modal re-renders via event delegation + a MutationObserver. */
(function () {
  'use strict';
  if (window.__ttAddonInit) return;
  window.__ttAddonInit = true;

  var BUNDLE_PID = '8375432184152';
  var PITCH_IMG = 'https://cdn.shopify.com/s/files/1/0028/4331/2240/files/Main_Image_38a47c16-1e22-42c9-b33d-9da175927a09.png?width=140';
  var BASE_IMG = 'https://cdn.shopify.com/s/files/1/0028/4331/2240/files/MainImage_12.png?width=140';
  var COURSES = [
    { v: '56709552767320', key: 'pitching', fbItem: 2522847, name: 'Tidal Tank for Pitching Program with Misiorowski', href: '/products/tidal-tank-for-pitching-program', img: PITCH_IMG },
    { v: '56202951491928', key: 'baseball', fbItem: 2715544, name: 'Tidal Tank for Baseball Program', href: '/products/tidal-tank-for-baseball-program-1', img: BASE_IMG }
  ];
  // Fast Bundle add-on offer "Select your free course" (id 487683). Fast Bundle makes the courses
  // free (its own "BUNDLE" discount) once the cart is registered against this offer - the same
  // call its product-page widget makes. bundle item id 214255 = Baseball Bundle 2.0 in that offer.
  var FB_OFFER = { id: 487683, uuid: 'b155054a-a764-40b1-8426-c92466c934bc', bundleItem: 214255 };

  function registerFastBundle(mainId, variants) {
    var shop = (window.Shopify && window.Shopify.shop) || 'tidal-tank.myshopify.com';
    var bv = [{ variant_id: mainId, collection_item_id: FB_OFFER.bundleItem }];
    variants.forEach(function (v) {
      var c = COURSES.filter(function (x) { return String(x.v) === String(v); })[0];
      if (c) bv.push({ variant_id: v, item_id: c.fbItem });
    });
    var post = function () {
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        return fetch('https://api.fastbundle.co/v1/carts/bundles/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Fastbundle-Request': 'yes', 'FB-SHOP-DOMAIN': shop },
          body: JSON.stringify({ token: cart.token, bundle: FB_OFFER.id, show_uuid: FB_OFFER.uuid, shop: shop, user_ip: '',
            click_from_url: window.location.pathname, click_from_page_type: 'page', bundle_variants: bv, is_single_bap: false })
        });
      }).then(function (r) { if (!r.ok) throw new Error('fastbundle register HTTP ' + r.status); });
    };
    // Register (retry once on a network/HTTP error), then make Fast Bundle re-check until $0.
    return post().catch(function (e) {
      console.warn('[tt-addon] retry register', e);
      return new Promise(function (res) { setTimeout(res, 700); }).then(post);
    }).catch(function (e) { console.error('[tt-addon] fast bundle register', e); }).then(function () {
      return recheckUntilFree(variants, 3, post);
    }).catch(function (e) { console.error('[tt-addon] fast bundle check', e); });
  }

  // Make Fast Bundle re-check the cart NOW (writes its "BUNDLE" discount via __fbData).
  // rbrCartHandler() is NOT enough: it skips the server check when the cart lines are unchanged
  // since its last check. On a brand-new cart, Fast Bundle's own check (fired by the Add-to-cart
  // click) often runs before our bundle record exists, caches "no discount" for these exact lines,
  // and rbrCartHandler then does nothing -> courses stay $100. detectBundleDiscounts() forces it.
  function forceFastBundleCheck() {
    try {
      if (typeof window.detectBundleDiscounts === 'function') return Promise.resolve(window.detectBundleDiscounts());
      if (typeof window.rbrCartHandler === 'function') return Promise.resolve(window.rbrCartHandler());
    } catch (e) { console.error('[tt-addon] fast bundle check', e); }
    return Promise.resolve();
  }

  // Force the check, wait for $0 courses. If still not free (a late Fast Bundle answer overwrote
  // ours, or the record was lost), register again and force again. Max 3 rounds (~10s worst case).
  function recheckUntilFree(variants, rounds, post) {
    return forceFastBundleCheck().catch(function () {}).then(function () {
      return waitForFreeCourses(variants, 6);
    }).then(function (free) {
      if (free || rounds <= 1) { if (!free) console.warn('[tt-addon] courses not free after retries'); return; }
      return post().catch(function () {}).then(function () { return recheckUntilFree(variants, rounds - 1, post); });
    });
  }

  // Fast Bundle writes its discount a moment after the re-check. Poll the cart (max ~3s) until the
  // ticked courses are $0, so the drawer is drawn with the right prices. Resolves true when free.
  function waitForFreeCourses(variants, triesLeft) {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var done = variants.every(function (v) {
        return cart.items.some(function (i) { return String(i.variant_id) === String(v) && i.final_line_price === 0; });
      });
      if (done) return true;
      if (triesLeft <= 0) return false;
      return new Promise(function (res) { setTimeout(res, 500); }).then(function () { return waitForFreeCourses(variants, triesLeft - 1); });
    });
  }

  var CSS = '' +
    '.tt-addon{margin:18px 0 16px;font-family:inherit}' +
    '.tt-addon__head{display:flex;align-items:center;flex-wrap:wrap;gap:10px;margin-bottom:12px}' +
    '.tt-addon__title{font-weight:700;font-size:18px;line-height:1.2;color:#1c1c1d}' +
    '.tt-addon__gift{display:inline-flex;align-items:center;background:#D7212C;color:#fff;font-weight:700;font-size:12px;letter-spacing:.02em;padding:4px 10px;border-radius:6px;white-space:nowrap}' +
    '.tt-addon__item{display:flex;align-items:center;gap:12px;border:1px solid #e4e7eb;border-radius:12px;padding:12px 14px;margin-bottom:10px;cursor:pointer;transition:border-color .15s,box-shadow .15s,background .15s;background:#fff}' +
    '.tt-addon__item:hover{border-color:#c7ccd3}' +
    '.tt-addon__item:has(.tt-addon__check:checked){border-color:#256AD1;box-shadow:0 0 0 1px #256AD1 inset;background:#f7fbff}' +
    '.tt-addon__check{position:absolute;opacity:0;width:0;height:0}' +
    '.tt-addon__box{flex:0 0 auto;width:22px;height:22px;border:2px solid #c7ccd3;border-radius:6px;background:#fff;position:relative;transition:border-color .15s,background .15s}' +
    '.tt-addon__item:has(.tt-addon__check:checked) .tt-addon__box{background:#256AD1;border-color:#256AD1}' +
    '.tt-addon__box:after{content:"";position:absolute;left:6px;top:2px;width:6px;height:11px;border:solid #fff;border-width:0 2px 2px 0;transform:rotate(45deg) scale(0);transition:transform .12s}' +
    '.tt-addon__item:has(.tt-addon__check:checked) .tt-addon__box:after{transform:rotate(45deg) scale(1)}' +
    '.tt-addon__check:focus-visible + .tt-addon__box{outline:2px solid #256AD1;outline-offset:2px}' +
    '.tt-addon__thumb{flex:0 0 auto;width:56px;height:56px;object-fit:cover;border-radius:8px;background:#f2f4f7;border:1px solid #eef1f4}' +
    '.tt-addon__info{display:flex;flex-direction:column;gap:3px;min-width:0}' +
    '.tt-addon__name{font-weight:600;font-size:15px;line-height:1.25;color:#1c1c1d}' +
    '.tt-addon__ext{color:#256AD1;text-decoration:none;font-size:13px;margin-left:2px}' +
    '.tt-addon__price{font-size:14px;color:#5b6470}' +
    '.tt-addon__free{color:#16a34a;font-weight:700;margin-right:4px}' +
    '.tt-addon__price s{color:#9aa1ab}' +
    '@media (max-width:915px){.tt-addon__title{font-size:16px}.tt-addon__item{padding:10px 12px;gap:10px}.tt-addon__thumb{width:48px;height:48px}.tt-addon__name{font-size:14px}}';

  function injectCSS() {
    if (document.getElementById('tt-addon-css')) return;
    var s = document.createElement('style');
    s.id = 'tt-addon-css';
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  // Build the add-on element. idPrefix keeps checkbox ids unique per surface.
  function buildAddon(idPrefix) {
    var wrap = document.createElement('div');
    wrap.className = 'tt-addon';
    wrap.setAttribute('data-tt-addon', '');
    var html = '<div class="tt-addon__head"><span class="tt-addon__title">Pick your free programs</span><span class="tt-addon__gift">Bundle special</span></div>';
    COURSES.forEach(function (c) {
      var id = idPrefix + '-tt-' + c.key;
      html += '<label class="tt-addon__item" for="' + id + '">' +
        '<input type="checkbox" id="' + id + '" class="tt-addon__check" data-tt-variant="' + c.v + '">' +
        '<span class="tt-addon__box" aria-hidden="true"></span>' +
        '<img class="tt-addon__thumb" src="' + c.img + '" alt="' + esc(c.name) + '" loading="lazy" width="56" height="56">' +
        '<span class="tt-addon__info"><span class="tt-addon__name">' + esc(c.name) +
        ' <a href="' + c.href + '" target="_blank" rel="noopener" class="tt-addon__ext" aria-label="View product" onclick="event.stopPropagation();">↗</a></span>' +
        '<span class="tt-addon__price"><span class="tt-addon__free">Free</span> <s>$100.00</s></span></span></label>';
    });
    wrap.innerHTML = html;
    return wrap;
  }

  // Landing page: move the server-rendered add-on to sit right above the ATC.
  function relocate() {
    document.querySelectorAll('.complete-featured-product [data-tt-addon]').forEach(function (addon) {
      var scope = addon.closest('.complete-featured-product');
      var anchor = scope.querySelector('product-form') || scope.querySelector('.product-form--add-to-cart');
      if (anchor && anchor.parentNode && anchor.previousElementSibling !== addon) {
        anchor.parentNode.insertBefore(addon, anchor);
      }
    });
  }

  // Quick-add modal: inject the add-on above the ATC when the bundle's modal is populated.
  function handleModal() {
    document.querySelectorAll('quick-add-modal[id*="' + BUNDLE_PID + '"] product-info, .quick-add-modal[id*="' + BUNDLE_PID + '"] product-info').forEach(function (pi) {
      if (pi.querySelector('[data-tt-addon]')) return;
      var form = pi.querySelector('product-form');
      if (!form) return;
      var addon = buildAddon('qa' + BUNDLE_PID);
      form.parentNode.insertBefore(addon, form);
    });
  }

  // Landing-page products (Misiorowski etc.) render a full-page "Custom Complete Product"
  // section that cannot fit the quick-add modal. Send those to the product page instead.
  function handleLpModal() {
    var broken = document.querySelector('quick-add-modal product-info .complete-featured-product, .quick-add-modal product-info .complete-featured-product');
    if (!broken) return;
    var pi = broken.closest('product-info');
    var url = pi && (pi.getAttribute('data-url') || pi.getAttribute('data-product-url'));
    if (url) { window.location.href = url; }
  }

  function run() { try { injectCSS(); relocate(); handleModal(); handleLpModal(); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', run);
  [200, 700, 1500, 3000].forEach(function (t) { setTimeout(run, t); });
  try {
    var pending = false;
    var mo = new MutationObserver(function () {
      if (pending) return; pending = true;
      requestAnimationFrame(function () { pending = false; run(); });
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}

  function checkedVariantsIn(scope) {
    var out = [];
    scope.querySelectorAll('[data-tt-addon] .tt-addon__check:checked').forEach(function (el) {
      var v = parseInt(el.getAttribute('data-tt-variant'), 10);
      if (v && out.indexOf(v) === -1) out.push(v);
    });
    return out;
  }

  // Intercept Add to Cart for any product form whose product-info contains the add-on
  // (landing page OR quick-add modal). Capture phase runs before the theme's handler.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.nodeName !== 'FORM') return;
    var scope = form.closest('product-info') || form.closest('.complete-featured-product');
    if (!scope || !scope.querySelector('[data-tt-addon]')) return;
    var variants = checkedVariantsIn(scope);
    if (!variants.length) return; // no add-on chosen -> normal behavior (theme adds the main product)

    e.preventDefault();
    e.stopPropagation();

    var idInput = form.querySelector('[name=id]');
    var qtyInput = form.querySelector('[name=quantity]');
    var mainId = idInput ? parseInt(idInput.value, 10) : null;
    var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    if (!mainId) { form.submit(); return; }

    var items = [{ id: mainId, quantity: qty }];
    variants.forEach(function (v) { items.push({ id: v, quantity: 1 }); });

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var sections = (cart && cart.getSectionsToRender) ? cart.getSectionsToRender().map(function (s) { return s.id; }) : [];
    var quickModal = form.closest('quick-add-modal');

    var submitBtn = form.querySelector('[type=submit]');
    var spinner = form.querySelector('.loading__spinner');
    if (submitBtn) { submitBtn.setAttribute('aria-disabled', 'true'); submitBtn.classList.add('loading'); }
    if (spinner) spinner.classList.remove('hidden');

    var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    if (!/\.js(\?|$)/.test(addUrl)) addUrl += '.js';
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
      body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response && response.status) {
          console.error('[tt-addon] add error', response);
          var wrap = form.querySelector('.product-form__error-message-wrapper');
          var msg = form.querySelector('.product-form__error-message');
          if (wrap && msg) { msg.textContent = response.description || response.message || 'Could not add to cart'; wrap.removeAttribute('hidden'); }
          return;
        }
        // Register with Fast Bundle first so the drawer opens with the courses already at $0.
        return registerFastBundle(mainId, variants).then(function () {
          if (!cart || !cart.renderContents || !cart.getSectionsToRender) return response;
          var ids = cart.getSectionsToRender().map(function (s) { return s.id; });
          return fetch('/?sections=' + ids.join(','))
            .then(function (r) { return r.json(); })
            .then(function (sections) { response.sections = sections; return response; })
            .catch(function () { return response; });
        }).then(function (fresh) {
          var render = function () { if (cart && cart.renderContents) { if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty'); cart.renderContents(fresh); } else { window.location = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart'; } };
          if (quickModal && quickModal.hide) {
            try { quickModal.hide(true); } catch (e) {}
            setTimeout(render, 50);
          } else {
            render();
          }
        });
      })
      .catch(function (err) { console.error('[tt-addon]', err); window.location = '/cart'; })
      .finally(function () {
        if (submitBtn) { submitBtn.classList.remove('loading'); submitBtn.removeAttribute('aria-disabled'); }
        if (spinner) spinner.classList.add('hidden');
      });
  }, true);
  // Announcement-bar deep link: scroll to the deals grid when arriving via #deals.
  function scrollDeals() {
    try {
      if ((location.hash || '').toLowerCase() !== '#deals') return;
      var t = document.querySelector('#main-collection-filters') || document.querySelector('#ProductGridContainer') || document.querySelector('#product-grid');
      if (!t) return;
      var y = t.getBoundingClientRect().top + window.pageYOffset - 64; // offset for the fixed announcement bar
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    } catch (e) {}
  }
  if (document.readyState === 'complete') scrollDeals(); else window.addEventListener('load', scrollDeals);
  [400, 1000, 1800, 2800].forEach(function (t) { setTimeout(scrollDeals, t); });

})();
